import React from 'react';
import ContenutoHtmlInner from '../../molecules/helpers-contenuto-html/ContenutoHtmlInner';
import { Link } from '../link';

const FooterCopyright = (props) => {
  const copyrightYear = `Copyright © ${new Date().getFullYear()} - `;
  return (
    <>
      <div className='footer__copyright--container'>
        <div className='box-editorial footer__copyright--text'>
          <ContenutoHtmlInner
            rawContent={props.text}
            copyrightYear={copyrightYear}
          />
        </div>
      </div>
      {props.from !== 'landing' && (
        <span className='footer__copyright--text'>
          <Link to='https://www.ariadnedigital.it' title='Ariadne Digital'>
            Engineered by Ariadne Digital
          </Link>
        </span>
      )}
    </>
  );
};

export default FooterCopyright;
